import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Formik } from "formik";
import React, { useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { validateManualTransferReceiptFile } from "@hooks/useManualTransferCheckoutPayment";
import { ManualTransferReceiptAlert } from "./ManualTransferReceiptAlert";
import * as S from "./styles";

var ManualTransferPaymentGateway = function ManualTransferPaymentGateway(_ref) {
  var changeSubmitProgress = _ref.changeSubmitProgress,
      processPayment = _ref.processPayment,
      formRef = _ref.formRef,
      formId = _ref.formId,
      channels = _ref.channels;
  var fileInputRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showReceiptModal = _useState2[0],
      setShowReceiptModal = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      receiptModalMessage = _useState4[0],
      setReceiptModalMessage = _useState4[1];

  var initialChannel = channels && channels.length > 0 ? channels[0].name : "";

  var openReceiptModal = function openReceiptModal(message) {
    setReceiptModalMessage(message);
    setShowReceiptModal(true);
  };

  return React.createElement(Formik, {
    initialValues: {
      channelName: initialChannel,
      receiptFile: null
    },
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validate: function validate(values) {
      var errors = {};

      if (!values.channelName) {
        errors.channelName = "Debes seleccionar una forma de transferencia.";
      }

      return errors;
    },
    onSubmit: function onSubmit(values, _ref2) {
      var setSubmitting = _ref2.setSubmitting,
          setFieldError = _ref2.setFieldError,
          setFieldTouched = _ref2.setFieldTouched;
      var receiptError = validateManualTransferReceiptFile(values.receiptFile);

      if (receiptError) {
        setFieldTouched("receiptFile", true);
        setFieldError("receiptFile", receiptError);
        openReceiptModal(receiptError);

        if (changeSubmitProgress) {
          changeSubmitProgress(false);
        }

        setSubmitting(false);
        return;
      }

      if (changeSubmitProgress) {
        changeSubmitProgress(true);
      }

      if (values.receiptFile) {
        processPayment({
          channelName: values.channelName,
          receiptFile: values.receiptFile
        });
      }

      setSubmitting(false);
    }
  }, function (_ref3) {
    var values = _ref3.values,
        errors = _ref3.errors,
        touched = _ref3.touched,
        handleSubmit = _ref3.handleSubmit,
        setFieldValue = _ref3.setFieldValue,
        setFieldTouched = _ref3.setFieldTouched,
        setFieldError = _ref3.setFieldError;
    var selectedChannel = channels.find(function (channel) {
      return channel.name === values.channelName;
    });

    var handleReceiptFileChange = function handleReceiptFileChange(file) {
      setFieldValue("receiptFile", file);
      setFieldTouched("receiptFile", true, false);

      if (file) {
        var receiptError = validateManualTransferReceiptFile(file);

        if (receiptError) {
          setFieldError("receiptFile", receiptError);
        } else {
          setFieldError("receiptFile", undefined);
          setShowReceiptModal(false);
        }
      } else {
        setFieldError("receiptFile", undefined);
      }
    };

    return React.createElement(React.Fragment, null, React.createElement(S.Form, {
      id: formId,
      ref: formRef,
      onSubmit: handleSubmit,
      "data-test": "manualTransferPaymentGatewayForm"
    }, React.createElement(S.Wrapper, null, React.createElement(S.HelpText, null, React.createElement(FormattedMessage, {
      id: "@next.components.organisms.ManualTransferPaymentGateway.ManualTransferPaymentGateway.1286135691",
      defaultMessage: "Selecciona c\xF3mo vas a transferir y adjunta el comprobante para continuar."
    })), React.createElement(S.ChannelList, null, channels.map(function (channel) {
      return React.createElement(S.ChannelOption, {
        key: channel.name,
        checked: values.channelName === channel.name
      }, React.createElement("input", {
        type: "radio",
        name: "manual-transfer-channel",
        value: channel.name,
        checked: values.channelName === channel.name,
        onChange: function onChange() {
          setFieldValue("channelName", channel.name);
          setFieldTouched("channelName", true, false);
        }
      }), React.createElement(S.ChannelBody, null, React.createElement(S.ChannelTitle, null, channel.name), values.channelName === channel.name && React.createElement(React.Fragment, null, React.createElement(S.ChannelDescription, null, channel.description), channel.imageUrl ? React.createElement(S.ChannelImage, {
        src: channel.imageUrl,
        alt: channel.name
      }) : null)));
    })), touched.channelName && errors.channelName ? React.createElement(S.ErrorText, null, errors.channelName) : null, React.createElement(S.FileField, null, React.createElement(S.FileLabel, null, React.createElement(FormattedMessage, {
      id: "@next.components.organisms.ManualTransferPaymentGateway.ManualTransferPaymentGateway.2756598230",
      defaultMessage: "Comprobante de transferencia"
    })), React.createElement(S.FileUploadRow, null, React.createElement(S.HiddenFileInput, {
      ref: fileInputRef,
      id: "manual-transfer-receipt",
      "data-test": "manualTransferReceiptInput",
      type: "file",
      accept: "image/jpeg,image/png,image/webp",
      onChange: function onChange(event) {
        var input = event.currentTarget;
        var file = input.files && input.files.length > 0 ? input.files[0] : null;
        handleReceiptFileChange(file);
      }
    }), React.createElement(S.UploadReceiptButton, {
      type: "button",
      "data-test": "manualTransferSelectReceiptButton",
      onClick: function onClick() {
        var _fileInputRef$current;

        return (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();
      }
    }, React.createElement(FormattedMessage, {
      id: "@next.components.organisms.ManualTransferPaymentGateway.ManualTransferPaymentGateway.3807589440",
      defaultMessage: "Agregar comprobante"
    })), React.createElement(S.FileName, {
      "data-test": "manualTransferReceiptFileName"
    }, values.receiptFile ? values.receiptFile.name : "Ningún archivo seleccionado")), React.createElement(S.HelpText, null, React.createElement(FormattedMessage, {
      id: "@next.components.organisms.ManualTransferPaymentGateway.ManualTransferPaymentGateway.2494507201",
      defaultMessage: "JPG, PNG o WEBP. La foto se optimiza autom\xE1ticamente al enviar."
    })), touched.receiptFile && errors.receiptFile ? React.createElement(S.ErrorText, null, errors.receiptFile) : null), selectedChannel && values.receiptFile && !errors.receiptFile ? React.createElement(S.HelpText, null, React.createElement(FormattedMessage, {
      id: "@next.components.organisms.ManualTransferPaymentGateway.ManualTransferPaymentGateway.607417384",
      defaultMessage: "Comprobante listo. Pulsa Continuar para validar el pago."
    })) : null)), showReceiptModal ? React.createElement(ManualTransferReceiptAlert, {
      message: receiptModalMessage,
      onClose: function onClose() {
        return setShowReceiptModal(false);
      },
      onAddReceipt: function onAddReceipt() {
        var _fileInputRef$current2;

        setShowReceiptModal(false);
        (_fileInputRef$current2 = fileInputRef.current) === null || _fileInputRef$current2 === void 0 ? void 0 : _fileInputRef$current2.click();
      }
    }) : null);
  });
};

export { ManualTransferPaymentGateway };